import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker' 
import logout from './../../Global/logout' 

export default async function CreatePosProstor(
    clientUuid,
    label,
    address,
    description,
    premises_name,
    ecommerce
) {
    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }

    return await resolve(
        axios( 'provider/client/businessPremises?clientUuid=' + clientUuid, {
            method: 'post',
            headers: { 
                'Authorization' : unHashedJwt.data                 
            },
            data: {
                "label": label.trim(),
                "address": address.trim(),
                "description": description.trim(),
                "premises_name": premises_name.trim(),
                "ecommerce": ecommerce
            }      
        }).then(res => res.data)
        .catch(error => error.response.data),
        "Admin"
        );
}